<div [ngClass]="cssClass">
  <div class="copyright" [ngClass]="{'has-external-link': externalLink}" (click)="openLink()">
    <span class="prefix">{{prefix}}</span>
    <ois-icon-wrapper *ngIf="iconPath" class="icon" [icon]="iconPath"></ois-icon-wrapper>
    <span *ngIf="fontIcon" class="icon">
      <ng-content></ng-content>
    </span>
    <span class="suffix">{{suffix}}</span>
  </div>
</div>
